// ======================= screens: ==========================

import { bars_enam, keyboardImagesNames, link_out } from '../../utils/DictionaryManagementUtils';
import { getFlowCode, getPathName, getUserTypesByService } from '../Utils/GeneralUtills';

export default function kbdMainScreens(configurations) {
  const screens = [];
  let index = 1;

  // ===== "Auth" screens: ==========================

  // ----- "authCredentials" screen -----
  {
    const authCredentials = {
      name: 'authCredentials',
      template: 'authCredentials001',
    };
    screens.push(authCredentials);
  }

  // ----- "authPinCode" screen -----
  {
    const authPinCode = {
      name: 'authPinCode',
      template: 'authPinCode001',
    };
    screens.push(authPinCode);
  }

  // ----- "authOtp" screen -----
  {
    const authOtp = {
      name: 'authOtp',
      template: 'authOtp001',
    };
    screens.push(authOtp);
  }

  // ----- "authBiometric" screen -----
  {
    const authBiometric = {
      name: 'authBiometric',
      template: 'authBiometric001',
    };
    screens.push(authBiometric);
  }
  // ----- "authBiometric" screen -----
  {
    const authPassword = {
      name: 'authPassword',
      template: 'authPassword001',
    };
    screens.push(authPassword);
  }

  // ===== "Error" screens: ==========================

  // ----- "landscapeError" screen -----
  {
    const landscapeError = {
      name: 'landscapeError',
      template: 'landscapeError001',
      imageElements: [{ name: 'image1', asset: keyboardImagesNames.ic_landscape_error }],
    };
    screens.push(landscapeError);
  }

  // ----- "connectionError" screen -----
  {
    const connectionError = {
      name: 'connectionError',
      template: 'connectionError001',
      imageElements: [{ name: 'image1', asset: keyboardImagesNames.ic_connection_error }],
    };
    screens.push(connectionError);
  }

  // ----- "transactionError" screen -----
  {
    const transactionError = {
      name: 'transactionError',
      template: 'transactionError001',
      imageElements: [{ name: 'image1', asset: keyboardImagesNames.ic_transaction_error }],
    };
    screens.push(transactionError);
  }

  // ----- "generalError" screen -----
  {
    const generalError = {
      name: 'generalError',
      template: 'generalError001',
      imageElements: [{ name: 'image1', asset: keyboardImagesNames.ic_general_error }],
    };
    screens.push(generalError);
  }

  // ----- "galleryPermission" screen -----
  {
    const generalError = {
      name: 'galleryPermission',
      template: 'galleryPermission001',
      imageElements: [{ name: 'image1', asset: keyboardImagesNames.ic_gallery_permission }],
    };
    screens.push(generalError);
  }

  // ===== "Menu" screens: ==========================
  const { services } = configurations;
  const { menu } = services;
  const { screens_ordering } = services;
  const { user_types } = configurations.deliverables;
  {
    const menu001 = {
      name: 'menu',
      template: 'menu001',
      textElements: [],
      imageElements: [],
      collectionElements: [],
    };
    const menu002 = {
      name: 'menu',
      template: 'menu002',
      textElements: [],
      imageElements: [],
      collectionElements: [],
    };
    // --- texts:
    if (menu.welcome_title) {
      menu001.textElements.push({ name: 'text1' });
      menu002.textElements.push({ name: 'text1' });
    }
    if (menu.show_account_balance) {
      menu001.textElements.push({ name: 'text2' });
      menu002.textElements.push({ name: 'text2' });
    }
    if (menu001.textElements.length === 0) {
      delete menu001.textElements;
      delete menu002.textElements;
    }
    // --- images:
    menu001.imageElements.push({ name: 'image1', asset: keyboardImagesNames.ic_bank_logo });
    menu002.imageElements.push({ name: 'image1', asset: keyboardImagesNames.ic_bank_logo });
    if (!menu.layout_menu_screen) {
      menu002.imageElements.push({ name: 'image2', asset: keyboardImagesNames.qab_menu_bank_logo });
    }
    // --- collectionElements:
    // --- menu001 --- //
    if (menu.icon_shape_bars_enam === bars_enam) {
      // bars - 1 per line
      index = 1;
      screens_ordering.forEach((serviceKey) => {
        const service = services[serviceKey];
        const imageName = service.icon.fName ? `ic_${serviceKey}` : `ic_${service.sub_category}`;
        if (service.selected) {
          menu001.collectionElements.push([
            {
              name: service.sub_category === link_out ? 'view8' : `view${index}`,
              actionPath: getPathName(
                service.sub_category,
                service.duplication_number,
              ),
              userTypes: getUserTypesByService(service.name, user_types),
              flowCode: getFlowCode(service),
              template: 'menuItem001',
              imageElements: [{ name: 'image1', asset: imageName }],
            },
          ]);
          index += 1;
        }
      });
    } else {
      // icons - 3 per line
      index = 1;
      let line = [];
      screens_ordering.forEach((serviceKey) => {
        const service = services[serviceKey];
        const imageName = service.icon.fName ? `ic_${serviceKey}` : `ic_${service.sub_category}`;
        if (service.selected) {
          line.push({
            name: service.sub_category === link_out ? 'view8' : `view${index}`,
            actionPath: getPathName(service.sub_category, service.duplication_number),
            userTypes: getUserTypesByService(service.name, user_types),
            flowCode: getFlowCode(service),
            template: 'menuItem002',
            imageElements: [{ name: 'image1', asset: imageName }],
          });
          index += 1;

          if (line.length === 3) {
            menu001.collectionElements.push(line);
            line = [];
          }
        }
      });
      if (line.length > 0) {
        menu001.collectionElements.push(line);
      }
    }
    // --- menu002 --- //
    index = 1;
    const line = [];
    screens_ordering.forEach((serviceKey) => {
      const service = services[serviceKey];
      const imageName = `ic_${service.sub_category}`;
      if (service.selected) {
        line.push({
          name: service.sub_category === link_out ? 'view8' : `view${index}`,
          actionPath: getPathName(service.sub_category, service.duplication_number),
          userTypes: getUserTypesByService(service.name, user_types),
          flowCode: getFlowCode(service),
          template: 'menuItem003',
          imageElements: [{ name: 'image1', asset: imageName }],
        });
        index += 1;
      }
    });
    if (line.length > 0) {
      menu002.collectionElements.push(line);
    }
    if (menu.layout_menu_screen) {
      screens.push(menu001);
    } else {
      screens.push(menu002);
    }
  }

  return screens;
}
